module.exports = __webpack_public_path__ + "static/media/thankYouImage.e76cf0e8.png";